import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Billing/Context';
import Form from '../PaymentMethods/Form';
import Field from './Field';

export default function Index({ paymentMethod }) {
  const { actions } = useContext();
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [billingInformation, setBillingInformation] = useState(null);

  useEffect(() => {
    if (paymentMethod === null) {
      actions.prepareBillingInformation((data) => {
        setBillingInformation(data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <section>
      <div className="d-flex">
        <h4>Billing Information</h4>
        {!loading && (
        <Button
          variant="link"
          className="icon-with-text ms-3"
          onClick={() => setShowEditModal(true)}
        >
          <i className="edit-icon small-icon" />
        </Button>
        )}
      </div>

      {loading ? (
        <LoadingPlaceholder text="Loading..." className="my-4" />
      ) : (
        <>

          <Form
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            initValue={paymentMethod || billingInformation}
          />

          <Row>
            <Col xl="6">
              <Field title="Bill To">
                {(paymentMethod || billingInformation).attributes.name}
              </Field>

              <Field title="Email">
                {(paymentMethod || billingInformation).attributes.email}
              </Field>

              <Field title="Country">
                {(paymentMethod || billingInformation).attributes.country}
              </Field>
            </Col>

            <Col xl="6">
              <Field title="City">
                {(paymentMethod || billingInformation).attributes.city}
              </Field>

              <Field title="Address">
                {(paymentMethod || billingInformation).attributes.address_line1}
                {' '}
                {(paymentMethod || billingInformation).attributes.address_line2}
              </Field>

              <Field title="Postal Code">
                {(paymentMethod || billingInformation).attributes.postal_code}
              </Field>
            </Col>
          </Row>
        </>
      )}
    </section>
  );
}

Index.propTypes = {
  paymentMethod: PropTypes.object,
};

Index.defaultProps = {
  paymentMethod: null,
};
